import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ClienteInterface } from "../../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import { FormatterCPF } from "../../../../../Validations/InputMasks";

interface IClientesRowProps {
    row: ClienteInterface;
}

export default function ClientesRow(props: IClientesRowProps) {
    const cliente = props.row;

    return (
        <div
            key={cliente.ID_CONTA}
            className="card card-custom cliente-card cursor-pointer"
        >
            <div className="card-body pt-3 pb-3">
                <div className="d-flex ">
                    <div className="flex-grow-1">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="mr-3">
                                <span className="d-flex align-items-center text-dark text-hover-primary font-size-h2 font-weight-bold mr-3">
                                    {cliente.DS_CONTA}
                                    <i className="flaticon2-correct text-success icon-md ml-2"></i>
                                </span>
                                <div className="d-flex flex-wrap my-2">
                                    {cliente.DS_EMAIL && (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip
                                                    id="email-tooltip"
                                                    className={`cliente-tooltip ${
                                                        cliente.DS_EMAIL
                                                            .length <= 1 &&
                                                        "tooltip-disabled"
                                                    } `}
                                                >
                                                    <div className="d-flex flex-column">
                                                        {cliente.DS_EMAIL.map(
                                                            (email) => {
                                                                return (
                                                                    <span
                                                                        key={
                                                                            email
                                                                        }
                                                                    >
                                                                        {email}
                                                                    </span>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                </Tooltip>
                                            }
                                            trigger={["click"]}
                                        >
                                            <span className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24px"
                                                        height="24px"
                                                        viewBox="0 0 24 24"
                                                        version="1.1"
                                                    >
                                                        <g
                                                            stroke="none"
                                                            strokeWidth="1"
                                                            fill="none"
                                                            fillRule="evenodd"
                                                        >
                                                            <rect
                                                                x="0"
                                                                y="0"
                                                                width="24"
                                                                height="24"
                                                            ></rect>
                                                            <path
                                                                d="M21,12.0829584 C20.6747915,12.0283988 20.3407122,12 20,12 C16.6862915,12 14,14.6862915 14,18 C14,18.3407122 14.0283988,18.6747915 14.0829584,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,12.0829584 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z"
                                                                fill="#000000"
                                                            ></path>
                                                            <circle
                                                                fill="#000000"
                                                                opacity="0.3"
                                                                cx="19.5"
                                                                cy="17.5"
                                                                r="2.5"
                                                            ></circle>
                                                        </g>
                                                    </svg>
                                                </span>
                                                {cliente.DS_EMAIL[0]}
                                                {cliente.DS_EMAIL.length >
                                                    1 && (
                                                    <FontAwesomeIcon
                                                        icon={faPlus}
                                                        className="ml-2 text-success"
                                                    />
                                                )}
                                            </span>
                                        </OverlayTrigger>
                                    )}
                                    {cliente.NR_CPF && (
                                        <span className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                <i className="far fa-address-card"></i>
                                            </span>
                                            {FormatterCPF(cliente.NR_CPF)}
                                        </span>
                                    )}
                                    {cliente.NR_TELEFONE && (
                                        <span className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24px"
                                                    height="24px"
                                                    viewBox="0 0 24 24"
                                                    version="1.1"
                                                >
                                                    <g
                                                        stroke="none"
                                                        strokeWidth="1"
                                                        fill="none"
                                                        fillRule="evenodd"
                                                    >
                                                        <rect
                                                            x="0"
                                                            y="0"
                                                            width="24"
                                                            height="24"
                                                        />
                                                        <path
                                                            d="M7.13888889,4 L7.13888889,19 L16.8611111,19 L16.8611111,4 L7.13888889,4 Z M7.83333333,1 L16.1666667,1 C17.5729473,1 18.25,1.98121694 18.25,3.5 L18.25,20.5 C18.25,22.0187831 17.5729473,23 16.1666667,23 L7.83333333,23 C6.42705272,23 5.75,22.0187831 5.75,20.5 L5.75,3.5 C5.75,1.98121694 6.42705272,1 7.83333333,1 Z"
                                                            fill="#000000"
                                                            fillRule="nonzero"
                                                        />
                                                        <polygon
                                                            fill="#000000"
                                                            opacity="0.3"
                                                            points="7 4 7 19 17 19 17 4"
                                                        />
                                                        <circle
                                                            fill="#000000"
                                                            cx="12"
                                                            cy="21"
                                                            r="1"
                                                        />
                                                    </g>
                                                </svg>
                                            </span>
                                            {/* {formatedTelefone( */}
                                            {cliente.NR_TELEFONE[0]}
                                            {/* )} */}
                                            {cliente.NR_TELEFONE.length > 1 && (
                                                <FontAwesomeIcon
                                                    icon={faPlus}
                                                    className="ml-2"
                                                />
                                            )}
                                        </span>
                                    )}
                                    {cliente.DS_CARGO && (
                                        <span className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24px"
                                                    height="24px"
                                                    viewBox="0 0 24 24"
                                                    version="1.1"
                                                >
                                                    <g
                                                        stroke="none"
                                                        strokeWidth="1"
                                                        fill="none"
                                                        fillRule="evenodd"
                                                    >
                                                        <mask fill="white">
                                                            <use href="#path-1"></use>
                                                        </mask>
                                                        <g></g>
                                                        <path
                                                            d="M7,10 L7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 L17,10 L18,10 C19.1045695,10 20,10.8954305 20,12 L20,18 C20,19.1045695 19.1045695,20 18,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,12 C4,10.8954305 4.8954305,10 6,10 L7,10 Z M12,5 C10.3431458,5 9,6.34314575 9,8 L9,10 L15,10 L15,8 C15,6.34314575 13.6568542,5 12,5 Z"
                                                            fill="#000000"
                                                        ></path>
                                                    </g>
                                                </svg>
                                            </span>
                                            {cliente.DS_CARGO}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
